import UsersApi from '../services/users/UsersApi';
import React from 'react';
import { BUILDEE_SERVICES } from '../utilities/constants';

/**
 * ユーザーのサービス権限に関する汎用メソッドを集めたファイル
 */

/**
 * 調整会議のサービス権限を保持しているかどうかを取得する
 * @param {number}companyId サービス権限を取得したいユーザーが所属している会社ID
 * */
export const hasChoseiPermission = async companyId => {
  let result = false;
  try {
    const response = await UsersApi.fetchCompanyUserPermission(companyId);
    if (response) {
      result = response.data.entities.company_user_permission.use_chosei_flg;
    } else {
      console.warn(
        'companyUserPermissionUtil.js UsersApi.fetchCompanyUserPermission false',
        response
      );
    }
  } catch (error) {
    console.warn(
      'companyUserPermissionUtil.js UsersApi.fetchCompanyUserPermission exception',
      error
    );
  }
  return result;
};

/**
 * 入退場のサービス権限を保持しているかどうかを取得する
 * @param {number}companyId サービス権限を取得したいユーザーが所属している会社ID
 * */
export const hasNyutaiPermission = async companyId => {
  let result = false;
  try {
    const response = await UsersApi.fetchCompanyUserPermission(companyId);
    if (response) {
      result = response.data.entities.company_user_permission.use_nyutaijo_flg;
    } else {
      console.warn(
        'companyUserPermissionUtil.js UsersApi.fetchCompanyUserPermission false',
        response
      );
    }
  } catch (error) {
    console.warn(
      'companyUserPermissionUtil.js UsersApi.fetchCompanyUserPermission exception',
      error
    );
  }
  return result;
};

/**
 * 労務安全のサービス権限を保持しているかどうかを取得する
 * @param {number}companyId サービス権限を取得したいユーザーが所属している会社ID
 * */
export const hasRoanPermission = async companyId => {
  let result = false;
  try {
    const response = await UsersApi.fetchCompanyUserPermission(companyId);
    if (response) {
      result =
        response.data.entities.company_user_permission.use_green_file_flg;
    } else {
      console.warn(
        'companyUserPermissionUtil.js UsersApi.fetchCompanyUserPermission false',
        response
      );
    }
  } catch (error) {
    console.warn(
      'companyUserPermissionUtil.js UsersApi.fetchCompanyUserPermission exception',
      error
    );
  }
  return result;
};

/**
 * 労務安全のみのサービス権限を保持しているかどうかを取得する
 * @param {number}companyId サービス権限を取得したいユーザーが所属している会社ID
 * */
export const hasOnlyRouanPermission = async companyId => {
  const result = await Promise.all([
    getPermissionByServiceIdAndCompanyId(
      BUILDEE_SERVICES.CONFERENCE.ID,
      companyId
    ),
    getPermissionByServiceIdAndCompanyId(BUILDEE_SERVICES.ROAN.ID, companyId),
    getPermissionByServiceIdAndCompanyId(BUILDEE_SERVICES.NYUTAI.ID, companyId),
    getPermissionByServiceIdAndCompanyId(
      BUILDEE_SERVICES.PROGRESS.ID,
      companyId
    ),
  ]).then(responses => {
    const [
      conferencePermission,
      roanPermission,
      nyutaiPermission,
      progressPermission,
    ] = responses;
    if (conferencePermission || nyutaiPermission || progressPermission) {
      return false;
    } else if (roanPermission) {
      return true;
    } else {
      return false;
    }
  });
  return result;
};

/**
 * 遷移先にサービス権限があるかを返す
 * @param {number} serviceId 遷移先のBuildeeのサービスID
 * @param {number} companyId サービス権限を取得したいユーザーが所属している会社ID
 */
export const getPermissionByServiceIdAndCompanyId = async (
  serviceId,
  companyId
) => {
  let permission = false;
  switch (serviceId) {
    case BUILDEE_SERVICES.CONFERENCE.ID:
      permission = await hasChoseiPermission(companyId);
      break;
    case BUILDEE_SERVICES.ROAN.ID:
      permission = await hasRoanPermission(companyId);
      break;
    case BUILDEE_SERVICES.NYUTAI.ID:
      permission = await hasNyutaiPermission(companyId);
      break;
    case BUILDEE_SERVICES.PROGRESS.ID:
      permission = await hasNyutaiPermission(companyId);
      break;
    case BUILDEE_SERVICES.TRACKER.ID:
      permission = await hasChoseiPermission(companyId);
      break;
    default:
      break;
  }
  return permission;
};

/**
 * 権限がなかった時のエラーダイアログ
 */
export class noPermissionDialog extends React.Component {
  render() {
    return (
      <div
        className='dialog-sm-wide dialog--modal'
        onClick={e => {
          e.stopPropagation();
        }}
      >
        <div className='dialog-sm-wide__header'>
          <span className='dialog-sm-wide__title'>権限がありません</span>
        </div>
        <div className='dialog-sm-wide__body-min'>
          選択したサービスを利用する権限がありません。
          <br />
          <br />
          サービスを利用するには、自社の企業管理者ユーザーにサービス権限を設定していただく必要があります。
          <br />
          <br />
          企業管理者ユーザーはユーザー一覧から確認できます。
        </div>
        <div className='dialog-sm-wide__footer'>
          <button
            className='btn--sub'
            onClick={() => {
              this.props.dialog.callback.done();
            }}
          >
            了解
          </button>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/utilities/companyUserPermissionUtil.js